'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _commonFunc = require('appkit-react-utils/commonFunc');

var _TreeNode = require('./TreeNode');

var _TreeNode2 = _interopRequireDefault(_TreeNode);

var _reactClickOutside = require('react-click-outside');

var _reactClickOutside2 = _interopRequireDefault(_reactClickOutside);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var babelPluginFlowReactPropTypes_proptype_Node = require('react').babelPluginFlowReactPropTypes_proptype_Node || require('prop-types').any;

var babelPluginFlowReactPropTypes_proptype_CommonType = require('appkit-react-utils/commonType').babelPluginFlowReactPropTypes_proptype_CommonType || require('prop-types').any;

function findNode(nodes, value, parentStack) {
  for (var ii = 0; ii < nodes.length; ii++) {
    var n = nodes[ii];
    if (n.value === value) {
      return n;
    }

    parentStack && parentStack.push(n.value);
    var temp = n.children && findNode(n.children, value, parentStack);
    if (temp) {
      return temp;
    }
    parentStack && parentStack.pop();
  }
  return null;
}

//if all child in arr, so do parent
function postOrderTreeTreversal(node, arr) {
  var checked = arr.includes(node.value);
  if (checked) {
    return true;
  } else if (!node.children) {
    return checked;
  } else {
    var allChildChecked = true;

    node.children.forEach(function (child) {
      allChildChecked = postOrderTreeTreversal(child, arr) && allChildChecked;
    });

    if (allChildChecked) {
      arr.push(node.value);
      return true;
    } else {
      return false;
    }
  }
}

//if parent in arr, so do all child
function prerorderTreeTreversal(node, arr, parentAdd) {
  var checked = arr.includes(node.value);

  if (!checked && parentAdd) {
    arr.push(node.value);
    checked = true;
  }

  if (node.children) {
    node.children.forEach(function (child) {
      prerorderTreeTreversal(child, arr, checked);
    });
  }
}

function getAllSubchildren(node, arr) {
  var e = node.value;
  arr.push(e);

  if (node.children) {
    node.children.forEach(function (c) {
      getAllSubchildren(c, arr);
    });
  }

  return arr;
}

//pre-order: parent -> child
function addAllChildren2Arr(node, arr) {
  //add its child recursively
  var e = node.value;
  if (!arr.includes(e)) {
    arr.push(e);
  }

  if (node.children) {
    node.children.forEach(function (c) {
      addAllChildren2Arr(c, arr);
    });
  }
}

var Tree = function (_Component) {
  _inherits(Tree, _Component);

  function Tree(props) {
    _classCallCheck(this, Tree);

    var _this = _possibleConstructorReturn(this, (Tree.__proto__ || Object.getPrototypeOf(Tree)).call(this, props));

    _this.state = {
      checked: [],
      expanded: []
    };
    return _this;
  }

  _createClass(Tree, [{
    key: 'onExpand',
    value: function onExpand(node) {
      if (!this.props.expanded) {
        var value = node.value;
        var newExpanded = this.state.expanded.slice();
        if (newExpanded.includes(value)) {
          newExpanded = newExpanded.filter(function (e) {
            return e !== value;
          });
        } else {
          newExpanded.push(value);
        }
        this.setState({ expanded: newExpanded });
      }
      if (this.props.onExpand) {
        this.props.onExpand(node);
      }
    }
  }, {
    key: 'onCheck',
    value: function onCheck(node) {
      if (!this.props.checked) {
        this.toggleChecked(node);
      }
      if (this.props.onCheck) {
        this.props.onCheck(node);
      }
    }
  }, {
    key: 'toggleChecked',
    value: function toggleChecked(node) {
      var value = node.value;
      var newChecked = this.state.checked.slice();
      var parentStack = [];
      var singleNode = findNode(this.props.nodes, value, parentStack);
      var includedByParent = parentStack.some(function (p) {
        return newChecked.includes(p);
      });

      if (!newChecked.includes(value) && !includedByParent) {
        newChecked.push(value);
        addAllChildren2Arr(singleNode, newChecked);
        postOrderTreeTreversal(this.props.nodes[0], newChecked);

        this.setState({
          checked: newChecked
        });
      } else {
        //remove itsself and its parent
        parentStack.push(value);
        var subchildren = getAllSubchildren(singleNode, []);
        parentStack = parentStack.concat(subchildren);

        newChecked = newChecked.filter(function (e) {
          return !parentStack.includes(e);
        });

        postOrderTreeTreversal(this.props.nodes[0], newChecked);
        this.setState({
          checked: newChecked
        });
      }
    }
  }, {
    key: 'isNodeExpanded',
    value: function isNodeExpanded(node) {
      return (this.props.expanded || this.state.expanded).includes(node.value);
    }
  }, {
    key: 'initialNodes',
    value: function initialNodes(nodes) {
      var _this2 = this;

      return nodes.map(function (node) {
        var initialNode = _extends({}, node);
        initialNode.expanded = _this2.isNodeExpanded(node);

        if (Array.isArray(node.children) && node.children.length > 0) {
          initialNode.children = _this2.initialNodes(node.children);
        } else {
          initialNode.children = null;
        }
        return initialNode;
      });
    }
  }, {
    key: 'getNodesInTabOrder',
    value: function getNodesInTabOrder(nodes, resultArr) {
      var _this3 = this;

      var showCheckbox = this.props.showCheckbox;

      nodes.forEach(function (node) {
        var hasChild = Array.isArray(node.children) && node.children.length > 0;

        if (!showCheckbox) {
          if (hasChild) {
            resultArr.push(node);

            if (_this3.isNodeExpanded(node)) {
              _this3.getNodesInTabOrder(node.children, resultArr);
            }
          }
        } else {
          resultArr.push(node);
          if (hasChild && _this3.isNodeExpanded(node)) {
            _this3.getNodesInTabOrder(node.children, resultArr);
          }
        }
      });
    }
  }, {
    key: 'onKeyDown',
    value: function onKeyDown(e) {
      var isEnter = e.key === "Enter";
      var isTab = e.key === "Tab";
      var isDown = e.key === "ArrowDown";
      var isUp = e.key === "ArrowUp";
      var isSpace = e.key === " ";
      var isShift = e.shiftKey;
      var goUp = isTab && isShift || isUp;

      var preventDefault = true;
      var currentTabNode = this.state.currentTabNode;
      var _props = this.props,
          showCheckbox = _props.showCheckbox,
          disabled = _props.disabled,
          expandDisabled = _props.expandDisabled;


      if (disabled || expandDisabled) {
        return;
      }

      if (isTab || isDown || isUp) {
        var nodesInTab = [];
        this.getNodesInTabOrder(this.props.nodes, nodesInTab);
        var lastIndex = nodesInTab.length - 1;

        if (!currentTabNode) {
          this.setState({
            currentTabNode: isTab && isShift ? nodesInTab[lastIndex] : nodesInTab[0]
          });
        } else {
          var index = nodesInTab.map(function (e) {
            return e.value;
          }).indexOf(currentTabNode.value);
          if (goUp) {
            index--;
          } else {
            index++;
          }

          if (index < 0 || index > lastIndex) {
            this.setState({
              currentTabNode: null
            });
            preventDefault = false;
          } else {
            this.setState({
              currentTabNode: nodesInTab[index]
            });
          }
        }
      } else if (isEnter && currentTabNode) {
        this.onExpand({
          value: currentTabNode.value
        });
      } else if (showCheckbox && currentTabNode && isSpace) {
        this.onCheck({
          value: currentTabNode.value
        });
      }

      if (preventDefault) {
        e.preventDefault();
      }
    }
  }, {
    key: 'handleClickOutside',
    value: function handleClickOutside() {
      this.setState({
        currentTabNode: null
      });
    }
  }, {
    key: 'getDisabledStatus',
    value: function getDisabledStatus(node, parent, disabled) {
      if (disabled) {
        return true;
      }
      if (parent.disabled) {
        return true;
      }

      return Boolean(node.disabled);
    }
  }, {
    key: 'precalculateChecked',
    value: function precalculateChecked() {
      if (!this.props.showCheckbox) {
        return;
      }

      this.checked = (this.props.checked || this.state.checked || []).slice();
      prerorderTreeTreversal(this.props.nodes[0], this.checked);

      //decide from children ----> parent
      postOrderTreeTreversal(this.props.nodes[0], this.checked);
    }
  }, {
    key: 'renderTreeNode',
    value: function renderTreeNode(nodes, parent, level) {
      var _this4 = this;

      var _props2 = this.props,
          _props2$disabled = _props2.disabled,
          disabled = _props2$disabled === undefined ? false : _props2$disabled,
          expandDisabled = _props2.expandDisabled,
          showCheckbox = _props2.showCheckbox,
          showNodeIcon = _props2.showNodeIcon,
          collapseIcons = _props2.collapseIcons;
      var currentTabNode = this.state.currentTabNode;


      var isParentEmpty = (0, _commonFunc.isEmptyObject)(parent);

      var olClasses = (0, _classnames2.default)("a-tree-sub-node-list", {
        "nested": !isParentEmpty && nodes
      });

      var treeNodes = nodes.map(function (node) {
        var key = '' + node.value;
        var checked = _this4.props.showCheckbox && _this4.checked.includes(node.value);
        var children = _this4.renderChildNodes(node, level + 1);
        var nodeDisabled = _this4.getDisabledStatus(node, parent, disabled);

        return _react2.default.createElement(
          _TreeNode2.default,
          {
            key: key,
            checked: checked,
            className: node.className,
            disabled: nodeDisabled,
            expandDisabled: expandDisabled,
            expanded: node.expanded,
            visible: !isParentEmpty ? parent.expanded : true,
            icon: node.icon,
            keyboardHighlight: currentTabNode && key === currentTabNode.value,
            label: node.label,
            rawChildren: node.children,
            showCheckbox: showCheckbox,
            showNodeIcon: showNodeIcon,
            value: node.value,
            collapseIcons: collapseIcons,
            onCheck: _this4.onCheck.bind(_this4),
            onExpand: _this4.onExpand.bind(_this4)
          },
          children
        );
      });
      return _react2.default.createElement(
        'div',
        { className: olClasses },
        treeNodes
      );
    }

    //recursive rendering

  }, {
    key: 'renderChildNodes',
    value: function renderChildNodes(node, level) {
      if (node.children !== null && node.expanded) {
        return this.renderTreeNode(node.children, node || {}, level);
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          nodes = _props3.nodes,
          className = _props3.className,
          disabled = _props3.disabled,
          expandDisabled = _props3.expandDisabled;


      var _nodes = this.initialNodes(nodes);
      this.precalculateChecked(_nodes);
      var treeNodes = this.renderTreeNode(_nodes, {}, 0);
      var cn = (0, _classnames2.default)(className, "a-tree", {
        'a-tree-disabled': disabled
      });

      return _react2.default.createElement(
        'div',
        { className: cn,
          onKeyDown: this.onKeyDown.bind(this),
          tabIndex: disabled || expandDisabled ? -1 : 0 },
        treeNodes
      );
    }
  }]);

  return Tree;
}(_react.Component);

Tree.propTypes = {
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['default', 'large']),

  checked: _propTypes2.default.arrayOf(_propTypes2.default.string),
  expanded: _propTypes2.default.arrayOf(_propTypes2.default.string),
  expandDisabled: _propTypes2.default.bool,

  showCheckbox: _propTypes2.default.bool,
  showNodeIcon: _propTypes2.default.bool,

  collapseIcons: _propTypes2.default.arrayOf(_propTypes2.default.any)
};

Tree.displayName = 'Tree';

exports.default = (0, _reactClickOutside2.default)(Tree);